
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './types';

interface StepsFieldProps {
  form: UseFormReturn<FormValues>;
  showField: boolean;
}

export const StepsField: React.FC<StepsFieldProps> = ({ form, showField }) => {
  if (!showField) return null;
  
  return (
    <FormField
      control={form.control}
      name="steps"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Steps to Reproduce</FormLabel>
          <FormControl>
            <Textarea
              placeholder="What steps led to this issue?"
              className="min-h-[80px]"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
